import { render, staticRenderFns } from "./SocialliteLogin.vue?vue&type=template&id=2dbf274d&"
import script from "./SocialliteLogin.vue?vue&type=script&lang=js&"
export * from "./SocialliteLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\themes-coder\\rawal\\rawal-laravel11\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dbf274d')) {
      api.createRecord('2dbf274d', component.options)
    } else {
      api.reload('2dbf274d', component.options)
    }
    module.hot.accept("./SocialliteLogin.vue?vue&type=template&id=2dbf274d&", function () {
      api.rerender('2dbf274d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/SocialliteLogin.vue"
export default component.exports